const general = {
    'general': 'Algemeen',
    'general.yes': 'Ja',
    'general.no': 'Nee',
    'general.ok': 'Oké',
    'general.cancel': 'Annuleren',
    'general.example': 'Voorbeeld',

    'general.date': 'Datum',

    'general.active': 'Actief',
    'general.inactive': 'Inactief',

    'general.page_not_found': 'Pagina niet gevonden',
    'general.no_results_found': 'Geen resultaten gevonden',

    'general.no_attentions': 'Geen aandacht nodig',

    'general.dashboard': 'Dashboard',
    'general.settings': 'Instellingen',

    'general.select_option': 'Maak een keuze',
    'general.select_all': 'Selecteer alles',

    'general.name': 'Naam',
    'general.description': 'Beschrijving',
    'general.email': 'E-mailadres',
    'general.password': 'Wachtwoord',
    'general.password_confirm': 'Wachtwoord herhalen',

    'general.reseller': 'Reseller',
    'general.resellers': 'Resellers',

    'general.client': 'Klant',
    'general.clients': 'Klanten',

    'general.feed': 'Feed',
    'general.feeds': 'Feeds',

    'general.webshop': 'Webshop',
    'general.webshop_type': 'Type webshop',
    'general.webshops': 'Webshops',

    'general.fields': 'Velden',
    'general.field': 'Veld',

    'general.connection': 'Connectie',
    'general.connections': 'Connecties',

    'general.profile': 'Profiel',
    'general.profiles': 'Profielen',

    'general.brands': 'Merken',
    'general.brand': 'Merk',

    'general.categories': 'Categorieën',
    'general.category': 'Categorie',

    'general.attributes': 'Attributen',
    'general.attribute': 'Attribuut',

    'general.prices': 'Prijzen',
    'general.price': 'Prijs',

    'general.payment_interval': 'Betaald per',

    'general.product_groups': 'Productgroepen',
    'general.product_group': 'Productgroep',

    'general.customer_groups': 'Klant groepen',
    'general.customer_group': 'Klant groep',

    'general.rule': 'Regel',

    'general.marge': 'Prijs marge ( percentage )',

    'general.company': 'Bedrijf',
    'general.company.name': 'Bedrijfsnaam',
    'general.company.phone': 'Telefoonnummer',
    'general.company.website': 'Website (moet beginnen met http)',
    'general.company.iban': 'IBAN nummer',
    'general.company.chamber_of_commerce': 'KvK-nummer',
    'general.company.vat_number': 'BTW-nummer',
    'general.company.logo': 'Logo',

    'general.contact.name': 'Contactpersoon',
    'general.contact.firstname': 'Voornaam',
    'general.contact.middlename': 'Tussenvoegsel',
    'general.contact.lastname': 'Achternaam',
    'general.contact.phone': 'Telefoonnummer',
    'general.contact.email': 'E-mail',

    'general.address.street': 'Straat',
    'general.address.address': 'Straat en huisnummer',
    'general.address.zipcode': 'Postcode',
    'general.address.city': 'Woonplaats',
    'general.address.country': 'Land',
    'general.address.state': 'Provincie',

    'general.general_information': 'Algemene informatie',
    'general.company_information': 'Bedrijfsinformatie',
    'general.contact_information': 'Contactinformatie',
    'general.extra_information': 'Extra informatie',

    'general.invitation.invited': 'Uitgenodigd',
    'general.invitation.send_to': 'Uitnodiging verzonden naar',

    'general.send_invitation': 'Verstuur uitnodiging',
    'general.send_invitation.sending': 'Uitnodiging wordt verzonden...',

    'general.resend_invitation': 'Verstuur uitnodiging opnieuw',
    'general.resend_invitation.explanation': 'Je uitnodiging is verzonden naar %x. Voer een nieuw e-mailadres in om de uitnodiging opnieuw te verzenden.',
    'general.resend_invitation.sending': 'Uitnodiging wordt verzonden...',
    'general.resend_invitation.other_email': 'Verstuur uitnodiging naar ander e-mailadres',

    'general.save': 'Opslaan',
    'general.save.saving': 'Opslaan...',

    'general.save_changes': 'Wijzigingen opslaan',
    'general.save_changes.saving': 'Wijzigingen worden opgeslagen...',

    'general.continue_to_payment': 'Ga door naar betalen',
    'general.continue_with_request': 'Aanvraag indienen',
    'general.loading': 'Laden...',

    'general.goto.dashboard': 'Ga naar het dashboard',

    'general.register': 'Registreren',
    'general.register.step1': 'Registreren | Mijn Bedrijf informatie',
    'general.register.step2': 'Registreren | Mijn Contact informatie',
    'general.register.step3': 'Registreren | Mijn Abonnoment plan',

    'general.current.customers': 'Bestaande klanten',
    'general.payment': 'Betaling',
    'general.payment.reference': 'Betaalreferentie',
    'general.payments': 'Betalingen',

    'general.requests': 'Aanvragen',

    'general.subscription.expired': 'Abonnement verlopen',
    'general.subscription.false': 'Geen abonnement',
    'general.admin': 'Administrator',

    'general.status': 'Status',
    'general.exported': 'Geëxporteerd',

    'general.location.type': 'Locatie type',
    'general.sync': 'Sync',

    'general.supported.software': 'Ondersteunde software',

    'general.subscription': 'Abonnement',
    'general.subscription.type': 'Abonnement type',
    'general.subscription.option': 'Abonnement optie',

    'general.faq': 'Veel gestelde vragen',
    'general.about': 'Over ons',
    'general.contact': 'Contact',
    'general.conditions': 'Algemene voorwaarden Speedcon B.V.',

    'general.languages': 'Talen',
    'general.language': 'Taal',

    'general.file.choose': 'Kies bestand',
    'general.original': 'Origineel',
    'general.next_step': 'Volgende stap',
    'general.previous_step': 'Vorige stap',

    'general.search': 'Wat wil je zoeken?',

    'general.dot': 'Punt (.)',
    'general.comma': 'Komma (,)',
    'general.dotcomma': 'Puntkomma (;)',
    'general.tab': 'Tab',
    'general.pipe': 'Pijp (|)',
    'general.double.quote': 'Dubbele aanhalingstekens (\"\)',
    'general.single.quote': 'Enkele aanhalingsteken (\'\)',

    'general.alternative.categories': 'Alternatieve categorieen',

    'general.hour': 'Uur',
    'general.day': 'Dag(en)',
    'general.week': 'Week(en)',
    'general.month': 'Maand(en)',
    'general.sync_interval': 'Sync wijzigingen interval',
    'general.update_interval': 'Sync bijwerken interval',
    'general.interval': 'Interval',

    'general.profile.combine': 'Profiel combineren',

    'general.profile.add': 'Profiel toevoegen',
    'general.profile.edit': 'Profiel Aanpassen',

    'general.open': 'Open. Na het verifieren van je account kan je inloggen om het nogmaals te proberen',
    'general.paid': 'Betaald. Na het verifieren van je account kan je inloggen',
    'general.failed': 'Mislukt. Na het verifieren van je account kan je inloggen om het nogmaals te proberen',
    'general.expired': 'Verlopen. Na het verifieren van je account kan je inloggen om het nogmaals te proberen',
    'general.canceled': 'Geannuleerd. Na het verifieren van je account kan je inloggen om het nogmaals te proberen',

    'general.user.open': 'Even geduld, we controleren de status van de betaling...',
    'general.user.paid': 'Betaling is gelukt, we sturen je door naar de abonnementen pagina.',
    'general.user.failed': 'Betaling is mislukt, we sturen je door naar de abonnemente pagina waar je het opnieuw kunt proberen.',
    'general.user.expired': 'Betaling is verlopen, we sturen je door naar de abonnemente pagina waar je het opnieuw kunt proberen.',
    'general.user.canceled': 'Betaling is geannuleerd, we sturen je door naar de abonnemente pagina waar je het opnieuw kunt proberen.',
    'general.none': 'Geen',

    'general.account.created': 'Account aangemaakt. Je u kunt nu inloggen.',
    'general.account.delete': 'Ik wil mijn account verwijderen',

    'general.switch': 'Wisselen',

    'general.switch.reseller': 'Klant is nu gewisseld met de selecteerde reseller',

    'general.discount': 'Korting',
    'general.payment.yearly': 'Ik wil graag per jaar betalen (20% korting)',
    'general.payment.monthly': 'I wil graag per maand betalen',

    'general.stacktrace': 'Stacktrace',
};

export default general;
